import { useState } from "react";
import { Modal, Dropdown, Button } from "semantic-ui-react";

import CampaignScheduleForm from "routes/campaign/forms/CampaignScheduleForm";

function ScheduleModal({
  scheduleId,
  campaignId,
  newSchedule,
  isClone = false,
  noIcon = false,
  fetchData,
}) {
  const [modalOpen, setModalOpen] = useState(false);

  const handleOpen = () => {
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  const handleSuccess = async () => {
    await fetchData();
  };

  return (
    <Modal
      trigger={
        scheduleId ? (
          isClone ? (
            <Dropdown.Item
              onClick={handleOpen}
              content="Clone"
              icon={noIcon ? null : "clone"}
            />
          ) : (
            <Dropdown.Item
              onClick={handleOpen}
              content="Edit"
              icon={noIcon ? null : "edit"}
            />
          )
        ) : (
          <Button
            size="tiny"
            className="item-adder"
            content="New Schedule"
            onClick={handleOpen}
          />
        )
      }
      open={modalOpen}
      onClose={handleClose}
      size="fullscreen"
      onFocus={e => e.stopPropagation()}
      onClick={e => e.stopPropagation()}
      closeOnDimmerClick={false}
      closeIcon
    >
      <Modal.Header
        icon="calendar alternate outline"
        content={`${
          scheduleId ? (isClone ? "Clone" : "Edit") : "New"
        } Schedule`}
      />
      <Modal.Content>
        <CampaignScheduleForm
          onSuccess={handleSuccess}
          onClose={handleClose}
          campaignId={campaignId}
          newSchedule={newSchedule}
          scheduleId={scheduleId}
          isClone={isClone}
        />
      </Modal.Content>
    </Modal>
  );
}

export default ScheduleModal;
